<template>
    <div class="vue-sound-wrapper" :class="type">
        <button class="play-pause-btn btn btn-secondary" @click="togglePlay()">
            <font-awesome-icon icon="play" v-if="!playing"></font-awesome-icon>
            <font-awesome-icon icon="pause" v-if="playing"></font-awesome-icon>
        </button>
        <button class="reset-btn btn btn-secondary" v-if="progress > 0 || type === 'single'" @click="restart()">
            <font-awesome-icon icon="step-backward"></font-awesome-icon>
        </button>
        <div class="status-bar">
            <div class="play-bar" v-bind:style="{ width: progress + '%'}"></div>
            <div class="info">
                <span v-if="name != ''">{{name}}</span>
                <span v-if="loaded" class="float-right pr-1 time-display">{{currentTime}} / {{songLength}}</span>
            </div>
        </div>
        <audio v-bind:id="playerId" ref="audiofile" :src="base_url + url" style="display:none;">
            <source :src="base_url + url" type="audio/wav" />
        </audio>
    </div>
</template>

<script>
export default {
  props: {
    index: {
      type: String
    },
    name: String,
    playerPlaying: Boolean,
    url: String,
    type: {
      type: String,
      default: 'inline'
    },
    base_url: {
      type: String,
      default: process.env.API_URL
    }
  },
  data () {
    return {
      isMuted: false,
      loaded: false,
      playing: false,
      paused: false,
      progress: 0,
      progressStyle: '',
      uuid: 0,
      audio: null,
      currentPos: 0,
      totalDuration: 0,
      hideVolumeSlider: false,
      volumeValue: 7,
      timer: null
    }
  },
  created () {},
  watch: {
    url: function (nVal, oVal) {
      this.reset()
    }
  },
  methods: {
    togglePlay: function () {
      if (this.playing) {
        this.paused = !this.paused
        this.playing = !this.playing
        this.audio.pause()
      } else {
        this.paused = false
        this.audio.play()
        this.playing = true
        this.$emit('playing', this.playerId, this.index)
        this.$store.commit('setPlayerPlaying', this.playerId)
      }
    },
    play: function () {
      if (this.playing) return
      this.paused = false
      this.audio.play()
      this.playing = true
    },
    pause: function () {
      this.paused = true
      this.playing = false
      this.audio.pause()
    },
    mute: function () {
      this.isMuted = !this.isMuted
      this.audio.muted = this.isMuted
      // this.mutedStyle = toggleActive(this.mutedStyle)
      this.volumeValue = this.isMuted ? 0 : 75
    },
    _handleLoaded: function () {
      if (this.audio.readyState >= 2) {
        if (this.autoPlay) this.audio.play()
        this.loaded = true
        this.totalDuration = parseInt(this.audio.duration)

        if (this.type === 'single') {
          this.togglePlay()
        }
      } else {
        throw new Error('Failed to load sound file')
      }
    },
    _handlePlayingUI: function (e) {
      if (this.$store.state.playerPlaying !== this.playerId) this.pause()

      let currTime = parseFloat(this.audio.currentTime)
      this.currentPos = currTime
      let percentage = parseFloat(currTime / this.totalDuration * 100)
      this.progress = percentage
      if (percentage >= 100) {
        this.progress = 0
        this.paused = false
        this.playing = false
      }
    },
    _handlePlayPause: function (e) {
      if (
        e.type === 'pause' &&
        this.paused === false &&
        this.playing === false
      ) {
      }
    },
    init: function () {
      this.audio.addEventListener('timeupdate', this._handlePlayingUI)
      this.audio.addEventListener('loadeddata', this._handleLoaded)
      this.audio.addEventListener('pause', this._handlePlayPause)
      this.audio.addEventListener('play', this._handlePlayPause)
    },
    reset: function () {
      this.pause()
    },
    restart: function () {
      this.audio.currentTime = 0
      this.playing = true
      this.audio.play()
    }
  },
  computed: {
    playerId: function () {
      return 'player-' + this.index
    },
    currentTime () {
      var secNum = parseInt(this.currentPos, 10)
      var hours = Math.floor(secNum / 3600)
      var minutes = Math.floor((secNum - (hours * 3600)) / 60)
      var seconds = secNum - (hours * 3600) - (minutes * 60)

      if (minutes < 10) { minutes = '0' + minutes }
      if (seconds < 10) { seconds = '0' + seconds }
      return minutes + ':' + seconds
    },
    songLength () {
      var secNum = parseInt(this.totalDuration, 10)
      var hours = Math.floor(secNum / 3600)
      var minutes = Math.floor((secNum - (hours * 3600)) / 60)
      var seconds = secNum - (hours * 3600) - (minutes * 60)

      if (minutes < 10) { minutes = '0' + minutes }
      if (seconds < 10) { seconds = '0' + seconds }
      return minutes + ':' + seconds
    }
  },
  mounted () {
    this.audio = this.$el.querySelectorAll('audio')[0]
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// prompts/components/AudioPlayer.vue